import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.services';
import { AlertService } from 'src/app/_services/alert.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { FormArray, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { PopUpComponent } from 'src/app/common/pop-up/pop-up.component';
import { MatDialog } from '@angular/material/dialog';
import { COMMENT_APPENDER, COMMENT_APPLICABLE_METADATA_KEYS, MAX_CHARS, PORTAL_USER_INFO_KEY } from 'src/app/constants/portal-user-info';
import { MARK_FOR_DELETE_KEY, REASON_FOR_DELETE_KEY, REASON_FOR_DELETE_PROMPT } from 'src/app/constants/mark-for-delete';
//import { schema } from './schema.value';

@Component({
  selector: 'app-dialog-update',
  templateUrl: './dialog-update.component.html',
  styleUrls: ['./dialog-update.component.scss'],
  providers: [DatePipe]
})

export class DialogUpdateComponent implements OnInit {

  @ViewChild('editor') editor: JsonEditorComponent;
  @ViewChild('editorMult') editorMult: JsonEditorComponent;
  @ViewChild('initiateForm') initiateForm: NgForm;

  showData;

  options = new JsonEditorOptions();
  data: any = {
    products: [{
      name: 'car',
      product: [{
        name: 'honda',
        model: [
          { id: 'civic', name: 'civic' },
          { id: 'accord', name: 'accord' },
          { id: 'crv', name: 'crv' },
          { id: 'pilot', name: 'pilot' },
          { id: 'odyssey', name: 'odyssey' }
        ]
      }]
    }]
  };


  data2 = { ...this.data };
  options2 = new JsonEditorOptions();


  @Input() document: any;
  @Output() openMetaData = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<boolean>();
  @Output() refreshDetails = new EventEmitter<boolean>();
  propertyKeys: String[] = [];
  toggleUpdate: Boolean = true;
  updateMessage: Boolean = false;
  values: any[];
  properties: any;
  valuesForm: FormGroup;
  hideFields = ["SF Application ID", "Digitization User Info", "Portal User Info", "Reference Entities", "Source", "Legacy Folder ID", "Batch ID", "ImageTrust Document ID", "Deletion Requested By", "Deletion Requested Date"];
  isError = false;
  errorMessage = '';
  isAdmin = false;
  adminShowFields = ["Legacy Folder ID"];
  comment: string = "";
  portalUserInfo: any = {};
  deleteComment: string = "";

  constructor(
    private documentService: DocumentService,
    private alertService: AlertService,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {

    this.options2.language = 'en';
    this.options.mode = 'code';
    this.options2.mode = 'tree';
    this.options2.modes = this.options.modes = ['form', 'tree', 'view'];
    this.options2.statusBar = this.options.statusBar = false;
    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

    this.options2.onSelectionChange = () => {
      console.log(`onSelectionChange`)
    }
  }

  showJson(d) {
    return JSON.stringify(d, null, 2);
  }

  getData(data, index) {
    this.values[index].value = data;    
  }

  changeLog(event = null) {
    this.showData = this.editor.get();
  }

  updateList(values, key, event: any) {
    const currentDate = event.target.value;   
    if (key.name == "Key Date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        values['Key Year'] = dateStrFormat[0];
        values['Key Date'] = dateString;
        key['isError'] = false;
        this.initiateForm.controls[key.name].setErrors(null);
      } else {
        key['isError'] = true;
        this.initiateForm.controls[key.name].setErrors({'isError': true});
      }
    }
    if (key.data_type == "date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
        values[key.name] = dateString;
        key['isError'] = false;
        this.initiateForm.controls[key.name].setErrors(null);
      } else {
        key['isError'] = true;
        this.initiateForm.controls[key.name].setErrors({'isError': true});
      }
    }
  }

  ngOnInit(): void {
    var strArrayAttributes = []
    this.document.categoryMetaData.properties.forEach(element => {
      this.propertyKeys.push(element.name);
      if (!this.hideFields.includes(element.name)) {
        if (element.data_type == 'str array') {
          strArrayAttributes.push(element.name)
        }
      }
      if (this.hideFields.includes(element.name) && !this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (!this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = false
      } else {
        element["isHide"] = false
      }
    });
    this.values = Object.assign({}, this.document.metadata.properties)
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
      if (this.values[String(key)] == true) {
        this.values[String(key)] = "true";
      }
      if (this.values[String(key)] == false) {
        this.values[String(key)] = "false";
      }
      if (key.includes("Date")) {
        if (this.values[String(key)] != '' && this.values[String(key)] != null) {
          const d = new Date(this.values[String(key)]);
          const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
          let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
          this.values[String(key)] = dateString;
        }
      }      
    })
    if (strArrayAttributes.length > 0) {
      this.createValuesForm(strArrayAttributes)
    }
  }

  createValuesForm(arrayProperties) {
    var formControlObject = {}
    arrayProperties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.valuesForm = new FormGroup(
      formControlObject
    )
    this.setVaulesHandler(arrayProperties)
  }

  setVaulesHandler(arrayProperties) {
    var formData = {}
    arrayProperties.forEach(element => {
      this.deleteForm(0, element)
      if (this.values[element]) {
        var values = []
        this.values[element].forEach(arrayValue => {
          this.addNewValue(element)
          values.push({ value: arrayValue })
        });
        formData[element] = values
      } 
    });
    this.valuesForm.patchValue(formData)
  }

  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }

  addNewValue(property) {
    const control = <FormArray>this.valuesForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.valuesForm.get(property)
  }

  validData() {
    return new Promise((resolve, reject) => {
      var isValidData = true;
      if (this.properties["Placeholder UUID"] && this.properties["Placeholder UUID"] != "" && !this.properties["Placeholder UUID"].includes("PLCHD")) {
        isValidData = false;
      }
      resolve(isValidData)
    });
  }

  async updateMetadata() {
    this.isError = false;
    this.errorMessage = '';
    var updateReq = {
      "docId": this.document.documentId,
      "category_id": this.document.categoryId,
      "properties": {}
    }
    this.document.categoryMetaData.properties.forEach((obj, index) => {
      if (obj.data_type === "int") {
        this.properties[obj.name] = parseInt(this.values[obj.name]);
      }
      else if (obj.data_type === "date") {
        if (this.values[obj.name] == '' || this.values[obj.name] == null) {
          this.properties[obj.name] = undefined
        } else {
          const editField = new Date(this.values[obj.name]);          
          let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');          
          this.properties[obj.name] = dateString;
        }
      }
      else if (obj.data_type == "object") {
        this.properties[obj.name] = this.showData
      }

      else if (obj.data_type == "bool") {
        this.properties[obj.name] = false
        if (this.values[obj.name] === "true") {          
          this.properties[obj.name] = true
        }
      }
      else if (obj.data_type === "str") {
        if (
          this.properties[obj.name] !== undefined &&
          this.properties[obj.name] !== '' &&
          this.values[obj.name] === ''
        ) {
          this.properties[obj.name] = '';
        } 
        else if (this.values[obj.name] == '' || this.values[obj.name] == null) {
          this.properties[obj.name] = undefined
        }
        else {
          this.properties[obj.name] = this.values[obj.name]
        }
      }
      else if (obj.data_type == "str array") {
        var values = []       
        if (!this.hideFields.includes(obj.name)) {
          if (this.valuesForm.value[obj.name].length == 0 || this.valuesForm.value[obj.name] == null) {
            this.properties[obj.name] = []
          }
          else {
            this.valuesForm.value[obj.name].forEach(element => {
              values.push(element.value)
            });
            this.properties[obj.name] = values
          }
        }
      }
      else {
        this.properties[obj.name] = this.values[obj.name];
      }
    });

    let isValid = await this.validData();
    if (!isValid) {
      this.isError = true;
      this.errorMessage = 'Placeholder UUID is invalid, please correct the data';
      return;
    } else {

    // Complete request payload for appplicable metadata comments
    this.properties[PORTAL_USER_INFO_KEY] = this.portalUserInfo;
    if (this.properties[MARK_FOR_DELETE_KEY] == true && REASON_FOR_DELETE_KEY in this.properties) {
      this.properties[REASON_FOR_DELETE_KEY] = this.deleteComment;
      console.log(this.properties[REASON_FOR_DELETE_KEY])
    }

    
      updateReq.properties = this.properties;

      this.documentService.updateDocumentMetadata(updateReq)
        .subscribe(
          resp => {
            this.updateMessage = true;
            this.toggleUpdate = false;
            this.refreshDetails.emit(false)
            this.portalUserInfo = {}
          }
        ),
        error => {
          this.alertService.error(error);
        }
    }
  }

  trackByIndex(index, item) {
    return item.id;
  }

  onClose(): void {
    //this.dialogRef.close();
    this.openMetaData.emit(false)
  }

  onCancel() {
    this.close.emit(true)
  }

  makeOptions = () => new JsonEditorOptions();

  onSelectionChange (event: MatSelectChange) {
    let fieldName: string = String(event.source.ngControl.name);
    if (COMMENT_APPLICABLE_METADATA_KEYS.includes(fieldName)) {
      this.openDialog(fieldName)
    } else if (fieldName === MARK_FOR_DELETE_KEY) {
      this.openDeleteDialog()
    }
  }

  openDialog(fieldName: any): void {
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: 'Please enter a comment for this change (no more than ' + MAX_CHARS + ' characters:' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.comment = result.comment.trim();
        let key = fieldName + COMMENT_APPENDER;
        let documentPortalUserInfo = this.document.metadata.properties["Portal User Info"];

        console.log(documentPortalUserInfo)
        if (this.portalUserInfo && Object.keys(this.portalUserInfo).length === 0)
          this.portalUserInfo = JSON.parse(JSON.stringify(documentPortalUserInfo));

        console.log(this.portalUserInfo)

        if (this.comment.trim() != '') {
          if (this.portalUserInfo[key] && Object.keys(documentPortalUserInfo).length > 0) {
            let num = documentPortalUserInfo[key]?.length;
            let versions = Number.isNaN(num) || num === undefined ? 0: num;
            console.log(this.portalUserInfo[key].length + ' ' + versions)
            if (this.portalUserInfo[key].length > versions)
              this.portalUserInfo[key][versions] = {comment: this.comment, version: (versions + 1)}
            else {
              this.portalUserInfo[key].push({
                comment: this.comment,
                version: ++versions
              });
            }
          } else {
            this.portalUserInfo[key] = []
            this.portalUserInfo[key].push({
              comment: this.comment,
              version: 1
            });
          }
          console.log(this.portalUserInfo)
        }
      }
    });
  }

  openDeleteDialog(): void {
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: REASON_FOR_DELETE_PROMPT }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteComment = result.comment.trim()
      }
    });
  }
}
